import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardImg, CardBody, CardTitle, CardSubtitle } from 'reactstrap';
import { Badge, Button } from 'reactstrap';
import Icon from '@mdi/react';
import { mdiCogTransferOutline } from '@mdi/js';
import hostImage from '../../assets/images/host.png';
import _4PosHostImage from '../../assets/images/host_4pos.png';
import miniPcHostImage from '../../assets/images/host_minipc.png';
import otherHostImage from '../../assets/images/host_other.png';

import './HostResume.css';

const HostResume = ({ host, className, hideDetails, ...rest }) => {
    const { t } = useTranslation();
    const connected = host.isConnected();

    const image = host.isPi() ? hostImage : (
        host?.isMiniPc() ? miniPcHostImage : (
            host.is4Pos() ? _4PosHostImage : otherHostImage
        )
    );

    return (
        <div className={ `HostResume ${host?.isManaged() ? 'managed' : 'unmanaged'} ${className}` } { ...rest }>
            <Card className="card-outline">
                <CardHeader className="pb-0">
                    <CardTitle tag="h6" title={host.name}>
                        { host.name?.substring(0, 16) }
                        { host.isManaged() && hideDetails && (
                        <Button tag={ Link } to={`/devices/hosts/manage/${host._id}`} color={ 'link' }>
                            <Icon path={ mdiCogTransferOutline } color="white" size={ 1 } />
                        </Button>
                        )}
                    </CardTitle>
                </CardHeader>
                <div className="options d-flex justify-between gap-4 text-italic">
                    { <Badge color="info">{ host.piNumber() }</Badge>}
                    { host?.options?.pihyve?.version && <Badge color="dark">{ host.options.pihyve.version }</Badge>}
                    { host.isManaged() && (
                        <div className="d-flex gap-1">
                            <i className={`fa fa-print ${host?.options?.disable_printers_manager ? 'disabled' : 'enabled'}`} />&nbsp;
                            <i className={`fa fa-credit-card ${host?.options?.disable_efts_manager ? 'disabled' : 'enabled'}`} />&nbsp;
                        </div>
                    )}
                </div>
                <CardImg
                    top
                    width="100%"
                    src={ image }
                    alt="Host image cap"
                    className={ connected ? 'connected' : 'disconnected' }
                />
                { !hideDetails && (
                <CardBody>
                    <CardSubtitle tag="h6" className="mb-2 text-muted">
                        <Badge color={ connected ? 'success' : 'danger' }>
                            { t(`hosts.${host.connected ? 'connected' : 'disconnected'}`) }<br/>
                        </Badge>{' '}
                        { host?.options?.terminal_id && (
                        <Badge color="info">
                            { host.options.terminal_id }
                        </Badge>
                        )}
                    </CardSubtitle>
                    { host.isManaged() && (
                        <Button tag={ Link } to={`/devices/hosts/manage/${host._id}`} color={ 'info' } block>
                            <Icon path={ mdiCogTransferOutline } color="white" size={ 1 } />
                            { t('hosts.manage') }
                        </Button>
                    )}
                </CardBody>
                )}
            </Card>
        </div>
    );
}

export default HostResume;
